<template>
    <div name="feature" class="feature" id="feature">
		<div class="inner-feature">
			<div class="item-group">
				<div class="item item01">
					<strong class="tit">쉽고 편한 의료생활</strong>
					<p class="text">복잡한 절차와 번거로움이 당연했던 의료,<br>
						디지털 전환으로 더 편리한 의료생활을 누리세요.</p>
					<img class="image" src="../../assets/renew_mobile/img_feature01.jpg" alt="쉽고 편한 의료생활"/>
				</div>
				<div class="item item02">
					<strong class="tit">투명하고 수평적인 정보 공유</strong>
					<p class="text">환자와 의료진 간에 정보 불균형을 해소하고 투명한<br> 의료 정보를 바탕으로 편하게 소통할 수 있어요.</p>
					<img class="image" src="../../assets/renew_mobile/img_feature02.jpg" alt="투명하고 수평적인 정보 공유"/>
				</div>
				<div class="item item03">
					<strong class="tit">효율적인 시간 활용</strong>
					<p class="text">원하는 시간에 병원 예약이 가능하므로<br>
						기다림 없이 진료를 받을 수 있어요.</p>
					<img class="image" src="../../assets/renew_mobile/img_feature03.jpg" alt="효율적인 시간 활용"/>
				</div>
			</div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'feature',
    mounted: function()
    {
        // let eheight = $('.feature').outerHeight();
        $(window).scroll(function () {
            var height = $(document).scrollTop();
            // console.log(height);
            // let winHeight = $(window).height();
			if(height < 150)
            {
                $('.inner-feature .item01').css('display', `none`);
				$('.inner-feature .item02').css('display', `none`);
				$('.inner-feature .item03').css('display', `none`);
            }
            else if(height >= 150 && height <= 950)
            {
                $('.inner-feature .item01').css('display', `block`);
            }
            else if(height >= 950 && height <= 1350)
            {
				$('.inner-feature .item01').css('display', `block`);
                $('.inner-feature .item02').css('display', `block`);
            }
            else if(height >= 1350 && height <= 2400)
            {
				$('.inner-feature .item01').css('display', `block`);
				$('.inner-feature .item02').css('display', `block`);
                $('.inner-feature .item03').css('display', `block`);
            }
        });
    },
    methods: {} 
    }
</script>

<style scoped>

	.feature{
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
		min-height: 1697px;
		padding-top: 87px;
		z-index: 4;
		background: #fff;
		overflow: hidden;
	}
	.inner-feature{
		margin: 0 34px;
		padding: 70px 0;
	}
	.item-group{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.item + .item{
		margin-top: 67px;
	}
	.item .tit{
		font-size: 26px;
		font-weight: 600;
		color: #1A1A1A;
	}
	.item .text{
		display: block;
		margin-top: 10px;
		margin-bottom: 39px;
		font-size: 16px;
		font-weight: 400;
		color: #666;
	}
	.item .image{
		width: 100%;
	}
    .inner-feature .item01, .inner-feature .item02, .inner-feature .item03{
		display: none;
		animation: fadeInUp 1s;
	}
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    @keyframes fadeInUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    @keyframes fadeInUp3 {
        0% {
            opacity: 0;
            left: 50%;
            transform: translate(100%);
        }
        to {
            opacity: 1;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
    @media screen and (max-width: 360px){
        .feature{
            width: 100%;
            min-height: 484px;
            background: #fff;
        }
		.item .tit{
			font-size: 23px;
		}
		.item .text{
			font-size: 14px;
		}
		.feature .item .text br{
			display: none;
		}

        .h-title {
            justify-content: center;
            font-weight: 600;
            font-size: 23px;
            line-height: 30px;
            color: #1A1A1A;
            text-align: center;
            animation: fadeInUp 1s;
        }
        .text-impact{
            color: #004EDD;
        }
        .h-sub-title{
            text-align: center;
            justify-content: center;
            margin-top: 18px;
            font-weight: 400;
            font-size: 12px;
            color: #1A1A1A;
            animation: fadeInUp2 1s;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_main/Feature.vue